export default {
  name: "nodata",
  data() {
    return {
      
    };
  },
  props:{
    width:{
      default:'0'
    },
    height:{
      default:'0'
    },
    marginTop:{
      default:'0'
    },
    theme: {
      type: String,
    }
  },
};
